import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadoFactibilidadCorporativaENUM, sizeTab} from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import SolicitudesPendientesCorporativosTableMain from "./SolicitudesPendientesCorporativosTableMain";
import TableSolicitudesEdicion from "../../shared/TableSolicitudesEdicion";

export default function SolicitudesPendientesCorporativosPage() {

  const [valueTab, setValueTab] = useState(0);


  return (


    <SingleTableBoxScene
      title={"Solicitudes Pendientes Corporativos"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Por Revisar"} {...a11yProps(0)} />
          <Tab label={"En Revisión"} {...a11yProps(1)} />
          <Tab label={"Documentos Cargados"} {...a11yProps(2)} />
          <Tab label={"Corregidos"} {...a11yProps(3)} />
          <Tab label={"Aprobados"} {...a11yProps(4)} />
          <Tab label={"Rechazados"} {...a11yProps(5)} />
          {/* PRV-008: Tab para Solicitudes de Edición */}
          <Tab label={"Solicitudes de Edición"} {...a11yProps(6)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudesPendientesCorporativosTableMain/>
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <SolicitudesPendientesCorporativosTableMain
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.EN_REVISION}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudesPendientesCorporativosTableMain
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.DOCUMENTOS_CARGADOS}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <SolicitudesPendientesCorporativosTableMain
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.CORREGIDO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={4}>
        <SolicitudesPendientesCorporativosTableMain
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.APROBADO}
          canEditGlobal={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={5}>
        <SolicitudesPendientesCorporativosTableMain
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.CANCELADO}
          canEditGlobal={false}
        />
      </CustomTabPanel>

      {/* PRV-008: Panel para Solicitudes de Edición */}
      <CustomTabPanel value={valueTab} index={6}>
        <TableSolicitudesEdicion />
      </CustomTabPanel>

    </SingleTableBoxScene>






  );

}